<ng-container *transloco="let t">
    <div class="forgot-password-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="altair-form ml-auto mr-auto border-radius bg-white"
                    [class.card-borderd-theme]="themeService.isCardBorder()">
                    <div class="title text-center">
                        <h3>
                            {{t('forgot-your-password')}}
                        </h3>
                        <p class="ml-auto mr-auto">
                            {{t('forgot-your-password-msg')}}
                        </p>
                    </div>
                    <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('email-adress')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-email-address')}}
                                </mat-label>
                                <input matInput type="email" id="email" formControlName="email">
                            </mat-form-field>
                            <div class="error text-danger" *ngIf="authForm.get('email')!.hasError('required') && authForm.get('email')!.touched">
                                {{t('email-is-required')}}
                            </div>
                            <div class="error text-danger" *ngIf="authForm.get('email')!.hasError('email') && authForm.get('email')!.touched">
                                {{t('valid-email-address')}}
                            </div>
                        </div>
                        <button mat-button class="btn" type="submit" [disabled]="authForm.invalid">
                            {{t('send')}}
                        </button>
                        <div class="error text-danger" *ngIf="showAlert">
                            {{t('invalid-credentials')}}
                        </div>
                        <div class="text-center back-to-sign-in">
                            <a mat-button routerLink="/authentication/sign-in">
                                <i class="ri-arrow-left-s-line"></i>
                                {{t('back-to')}} {{t('sign-in')}}
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</ng-container>
